import { LiaLinkedin } from "react-icons/lia";

const FooterLinks = [
  {
    links: [
      {
        title: "About Us",
        link: "/about-us",
      },
      {
        title: "Events and Registration",
        link: "/events-and-registration",
      },
      {
        title: "FAQ",
        link: "/faq",
      },
      {
        title: "Terms and Conditions",
        link: "/terms-and-conditions",
      },
      {
        title: "Privacy Policy",
        link: "/privacy-policy",
      },
    ],
    socialMedia: [
      {
        title: "LinkedIn",
        icon: <LiaLinkedin />,
        url: "https://www.linkedin.com/company/pharma-sos/",
      },
    ],
  },
];

export default FooterLinks;
